import { useEffect, type ReactNode } from "react";

interface OverlayProps {
  onClose: () => void;
  children: ReactNode;
  align?: "center" | "top";
}

// Modal backdrop with Escape-to-close, body scroll lock, and click-outside.
// Children render their own dialog panel (with role="dialog").
export function Overlay({ onClose, children, align = "center" }: OverlayProps) {
  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        event.stopPropagation();
        onClose();
      }
    };
    document.addEventListener("keydown", onKey);
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = previousOverflow;
    };
  }, [onClose]);

  return (
    <div
      className={`overlay overlay-${align}`}
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) {
          onClose();
        }
      }}
    >
      {children}
    </div>
  );
}
